
import React from 'react';
import { Link } from 'react-router-dom';
import './404.css';

export default function Error404() {
  return (
    <div className="b-center error-page">
      <section className="error-container">
        <span>4</span>
        <span><span className="screen-reader-text">0</span></span>
        <span>4</span>
      </section>
      <h1>Ой! Страница не найдена!</h1>
      <p>Проверьте правильность ссылки и попробуйте еще раз.</p>
      <div className="link-container">
        <Link to="/" className="btn">Перейти на главную страницу</Link>
      </div>
    </div>
  );
}
